if (!customElements.get('product-sticky-bar')) {
  customElements.define(
    'product-sticky-bar',
    class ProductStickyBar extends HTMLElement {
      constructor() {
        super();
        this.sectionId = this.dataset.sectionId;
        this.formId = this.dataset.formId;
        this.checkoutUrl = this.dataset.checkoutUrl;
        this.secondaryUrl = this.dataset.secondaryUrl;
      }

      connectedCallback() {
        if (this.parentElement !== document.body) {
          document.body.appendChild(this);
        }

        this.stickyAtc = this.querySelector('[data-sticky-atc]');
        this.stickyAtcLabel = this.querySelector('[data-sticky-atc-label]');
        this.stickySecondary = this.querySelector('[data-sticky-secondary]');
        this.mainSubmit = document.getElementById(`ProductSubmitButton-${this.sectionId}`);
        this.productForm = document.getElementById(this.formId);

        if (!this.stickyAtc || !this.mainSubmit) return;

        this.stickyAtc.addEventListener('click', () => {
          if (this.mainSubmit.disabled || this.mainSubmit.getAttribute('aria-disabled') === 'true') return;
          this.mainSubmit.click();
        });

        if (this.stickySecondary) {
          this.stickySecondary.addEventListener('click', this.onSecondaryClick.bind(this));
        }

        this.syncFromMainButton();
        this.mainButtonObserver = new MutationObserver(() => this.syncFromMainButton());
        this.mainButtonObserver.observe(this.mainSubmit, {
          attributes: true,
          attributeFilter: ['disabled', 'aria-disabled'],
          childList: true,
          subtree: true,
        });

        if (typeof subscribe === 'function') {
          this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
            if (event?.data?.source !== 'product-form' || !this.pendingCheckout) return;
            this.pendingCheckout = false;
            window.location.href = this.checkoutUrl;
          });

          this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, () => {
            window.setTimeout(() => this.syncFromMainButton(), 150);
          });
        }
      }

      disconnectedCallback() {
        this.mainButtonObserver?.disconnect();
        this.cartUpdateUnsubscriber?.();
        this.variantChangeUnsubscriber?.();
      }

      syncFromMainButton() {
        const mainLabel = this.mainSubmit.querySelector('span:not(.sold-out-message)');
        if (mainLabel && this.stickyAtcLabel) {
          this.stickyAtcLabel.textContent = mainLabel.textContent.trim();
        }

        const isDisabled =
          this.mainSubmit.disabled || this.mainSubmit.getAttribute('aria-disabled') === 'true';

        this.stickyAtc.toggleAttribute('disabled', isDisabled);
        this.stickySecondary?.toggleAttribute('disabled', isDisabled);
      }

      onSecondaryClick() {
        if (this.secondaryUrl) {
          window.location.href = this.secondaryUrl;
          return;
        }

        if (this.mainSubmit.disabled || this.mainSubmit.getAttribute('aria-disabled') === 'true') return;

        this.pendingCheckout = true;
        this.mainSubmit.click();
      }
    }
  );
}
